import { inrAmountWordsFromText } from "@shared/lib/utils/inrAmountInWords";
import styles from "./styles.module.scss";

type InrAmountWordsLineProps = {
  value: string | number | null | undefined;
  className?: string;
};

export function InrAmountWordsLine({ value, className }: InrAmountWordsLineProps) {
  const words = inrAmountWordsFromText(value);

  if (!words) {
    return null;
  }

  return (
    <p
      className={[styles.words, className].filter(Boolean).join(" ")}
      title={words}
    >
      {words}
    </p>
  );
}
